import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"padding":"0 2%"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-10" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = {
  class: "row",
  style: {"margin-top":"15px"}
}
const _hoisted_6 = { class: "Report-settings" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "Report-switchText" }, "Скрыть настройки", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "Report-switchIcon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-up" })
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "Report-switchText" }, "Показать настройки", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "Report-switchIcon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  class: "collapse show multi-collapse",
  id: "collapse2"
}
const _hoisted_16 = { class: "Report-viewer" }
const _hoisted_17 = {
  id: "viewerRow",
  class: "row"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { id: "loadingPanelPlace" }, null, -1)
const _hoisted_19 = { id: "viewer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.reportTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DxButton, {
          class: "float-end",
          width: 36,
          type: "normal",
          icon: "info",
          hint: "Справка",
          "styling-mode": "contained",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowInfo()))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "Report-switch",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSwitchChange && _ctx.onSwitchChange(...args))),
          "data-bs-toggle": "collapse",
          "data-bs-target": ".multi-collapse",
          "aria-expanded": "false",
          "aria-controls": "collapse2"
        }, [
          (_ctx.isSettingsOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _renderSlot(_ctx.$slots, "reportSettings", {
            loading: _ctx.loading,
            toggleInfoDialog: _ctx.toggleInfoDialog
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_DxLoadPanel, {
          class: "report-loading-panel",
          style: {"z-index":"9999"},
          position: _ctx.loadingPanelPosition,
          visible: _ctx.loading,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
          "show-indicator": true,
          "show-pane": false,
          shading: false,
          "close-on-outside-click": false,
          message: 'Пожалуйста подождите. Отчет формируется...' + _ctx.timeMessage
        }, null, 8, ["position", "visible", "message"]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [
            [_vShow, !_ctx.loading]
          ])
        ])
      ])
    ])
  ]))
}